/* PattePlanet Refonte : noyau JS léger (sans dépendance, chargé en différé).
   Modules : dialogues, menu, révélations, panier (Section Rendering API), vignettes couleur, recherche prédictive. */
(function () {
  'use strict';

  var PP = (window.PP = window.PP || {});
  var cfg = PP.config || {};
  var S = PP.strings || {};
  var root = document.documentElement;

  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function on(el, ev, fn, opts) { if (el) el.addEventListener(ev, fn, opts); }
  PP.qs = qs; PP.qsa = qsa;

  /* ---------- Dialogues natifs (tiroir panier, menu mobile, guide des tailles) ---------- */
  function openDialog(dlg, trigger) {
    if (!dlg || dlg.open) return;
    dlg._trigger = trigger || document.activeElement;
    if (typeof dlg.showModal === 'function') dlg.showModal(); else dlg.setAttribute('open', '');
    document.body.classList.add('is-locked');
    dlg.dispatchEvent(new CustomEvent('pp:open'));
  }
  function closeDialog(dlg) {
    if (!dlg || !dlg.open) return;
    if (typeof dlg.close === 'function') dlg.close(); else dlg.removeAttribute('open');
  }
  PP.openDialog = openDialog; PP.closeDialog = closeDialog;

  qsa('dialog').forEach(function (dlg) {
    on(dlg, 'close', function () {
      if (!qsa('dialog[open]').length) document.body.classList.remove('is-locked');
      if (dlg._trigger && dlg._trigger.focus) dlg._trigger.focus();
    });
    on(dlg, 'click', function (e) { if (e.target === dlg) closeDialog(dlg); });
  });
  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-dialog-open]');
    if (open) {
      var d = document.getElementById(open.getAttribute('data-dialog-open'));
      if (d) { e.preventDefault(); openDialog(d, open); }
      return;
    }
    var close = e.target.closest('[data-dialog-close]');
    if (close) { var host = close.closest('dialog'); if (host) closeDialog(host); }
  });

  /* ---------- En-tête : état compact sans décalage + méga-menu ---------- */
  var header = qs('[data-header]');
  if (header) {
    var ticking = false;
    var update = function () {
      header.classList.toggle('is-compact', window.scrollY > 24);
      ticking = false;
    };
    on(window, 'scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    update();
  }
  var megaTriggers = qsa('[data-mega-trigger]');
  function closeMega(except) {
    megaTriggers.forEach(function (t) {
      if (t !== except) {
        t.setAttribute('aria-expanded', 'false');
        var p = document.getElementById(t.getAttribute('aria-controls'));
        if (p) p.hidden = true;
      }
    });
  }
  megaTriggers.forEach(function (t) {
    var panel = document.getElementById(t.getAttribute('aria-controls'));
    if (!panel) return;
    var item = t.closest('[data-mega-item]');
    var timer;
    var byHover = false;
    function show() { clearTimeout(timer); closeMega(t); t.setAttribute('aria-expanded', 'true'); panel.hidden = false; }
    function hide() { byHover = false; t.setAttribute('aria-expanded', 'false'); panel.hidden = true; }
    on(t, 'click', function (e) {
      e.preventDefault();
      /* ouvert par survol : le clic le garde ouvert au lieu de le refermer */
      if (byHover) { byHover = false; return; }
      if (t.getAttribute('aria-expanded') === 'true') hide(); else show();
    });
    if (item && window.matchMedia('(hover: hover)').matches) {
      on(item, 'mouseenter', function () { if (t.getAttribute('aria-expanded') !== 'true') byHover = true; show(); });
      on(item, 'mouseleave', function () { timer = setTimeout(hide, 160); });
    }
    on(item || t, 'keydown', function (e) { if (e.key === 'Escape') { hide(); t.focus(); } });
    on(item || t, 'focusout', function (e) {
      if (item && !item.contains(e.relatedTarget)) hide();
    });
  });
  on(document, 'click', function (e) { if (!e.target.closest('[data-mega-item]')) closeMega(); });

  /* ---------- Révélations au scroll (jamais sur le contenu LCP) ---------- */
  if (root.classList.contains('pp-motion') && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    PP.observeReveals = function (scope) {
      qsa('[data-reveal]:not(.is-in)', scope).forEach(function (el) { io.observe(el); });
    };
    PP.observeReveals();
    /* Filet : un défilement très rapide peut sauter un bloc sans que l'observateur ne le voie ; tout bloc déjà passé est révélé. */
    var swept = false;
    on(window, 'scroll', function () {
      if (swept) return;
      swept = true;
      requestAnimationFrame(function () {
        swept = false;
        qsa('[data-reveal]:not(.is-in)').forEach(function (el) {
          if (el.getBoundingClientRect().top < window.innerHeight * 0.92) { el.classList.add('is-in'); io.unobserve(el); }
        });
      });
    }, { passive: true });
  }

  /* ---------- Parallaxe très légère (transform uniquement, éléments visibles) ---------- */
  if (root.classList.contains('pp-motion') && 'IntersectionObserver' in window) {
    var plx = [];
    var plxTick = false;
    var plxIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { en.target._ppVisible = en.isIntersecting; });
      plxUpdate();
    });
    qsa('[data-parallax]').forEach(function (el) { el._ppVisible = false; plx.push(el); plxIO.observe(el); });
    var plxUpdate = function () {
      plxTick = false;
      var vh = window.innerHeight;
      plx.forEach(function (el) {
        if (!el._ppVisible) return;
        var r = el.parentNode.getBoundingClientRect();
        var d = (r.top + r.height / 2 - vh / 2) * parseFloat(el.getAttribute('data-parallax') || '0.05');
        el.style.transform = 'translate3d(0,' + Math.round(d * -1) + 'px,0) translateY(-50%)';
      });
    };
    if (plx.length) {
      on(window, 'scroll', function () { if (!plxTick) { plxTick = true; requestAnimationFrame(plxUpdate); } }, { passive: true });
    }
  }

  /* ---------- Panier ---------- */
  var drawer = document.getElementById('CartDrawer');
  var live = qs('[data-cart-live]');
  function announce(msg) { if (live) { live.textContent = ''; setTimeout(function () { live.textContent = msg; }, 30); } }

  function applySections(sections) {
    if (!sections || !sections['cart-drawer']) return;
    var doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
    var fresh = qs('[data-cart-drawer-content]', doc);
    var target = qs('[data-cart-drawer-content]');
    if (fresh && target) target.replaceChildren.apply(target, Array.prototype.slice.call(fresh.childNodes));
    var src = qs('[data-cart-count-source]', doc);
    var count = src ? src.getAttribute('data-cart-count-source') : null;
    if (count !== null) {
      qsa('[data-cart-count]').forEach(function (el) {
        el.textContent = count;
        el.hidden = count === '0';
      });
    }
  }
  function cartPost(url, payload) {
    payload.sections = 'cart-drawer';
    payload.sections_url = window.location.pathname;
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) { var err = new Error(data.description || data.message || 'cart'); err.data = data; throw err; }
        return data;
      });
    });
  }
  PP.cart = {
    add: function (items) {
      return cartPost(cfg.cartAddUrl || '/cart/add.js', { items: items }).then(function (d) { applySections(d.sections); return d; });
    },
    change: function (key, quantity) {
      return cartPost(cfg.cartChangeUrl || '/cart/change.js', { id: key, quantity: quantity }).then(function (d) { applySections(d.sections); return d; });
    },
    open: function (trigger) {
      if (drawer && cfg.cartType === 'drawer') openDialog(drawer, trigger); else window.location.href = cfg.cartUrl || '/cart';
    }
  };

  /* Ouverture du panier depuis l'en-tête */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-cart-open]');
    if (t && drawer && cfg.cartType === 'drawer') { e.preventDefault(); openDialog(drawer, t); }
  });

  /* Lignes du panier : quantité et retrait (délégation, protégé contre le double clic) */
  var cartBusy = false;
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cart-line-action]');
    if (!btn || cartBusy) return;
    e.preventDefault();
    var key = btn.getAttribute('data-line-key');
    var qty = parseInt(btn.getAttribute('data-quantity'), 10);
    if (!key || isNaN(qty)) return;
    cartBusy = true;
    var box = btn.closest('[data-cart-drawer-content]') || document.body;
    box.setAttribute('aria-busy', 'true');
    PP.cart.change(key, Math.max(0, qty)).then(function () {
      announce(S.cartUpdated || '');
    }).catch(function () {
      var err = qs('[data-cart-error]');
      if (err) { err.textContent = S.cartError || ''; err.hidden = false; }
    }).then(function () {
      cartBusy = false;
      var b = qs('[data-cart-drawer-content]');
      if (b) b.removeAttribute('aria-busy');
    });
  });

  /* Formulaires d'ajout au panier (fiche produit, ajout rapide) */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-add-to-cart-form]');
    if (!form) return;
    if (cfg.cartType !== 'drawer' && !form.hasAttribute('data-force-ajax')) return;
    e.preventDefault();
    if (form.getAttribute('data-busy') === 'true') return;
    var idField = form.elements['id'];
    var qtyField = form.elements['quantity'];
    if (!idField || !idField.value) return;
    var btn = form.querySelector('[type="submit"]');
    var label = btn ? btn.querySelector('[data-btn-label]') : null;
    var original = label ? label.textContent : '';
    var errBox = form.querySelector('[data-form-error]');
    if (errBox) { errBox.textContent = ''; errBox.hidden = true; }
    form.setAttribute('data-busy', 'true');
    if (btn) { btn.setAttribute('aria-disabled', 'true'); }
    if (label) label.textContent = S.adding || original;
    var props = {};
    qsa('[name^="properties["]', form).forEach(function (f) {
      var m = f.name.match(/^properties\[(.+)\]$/);
      if (m && f.value) props[m[1]] = f.value;
    });
    PP.cart.add([{ id: parseInt(idField.value, 10), quantity: qtyField ? Math.max(1, parseInt(qtyField.value, 10) || 1) : 1, properties: props }])
      .then(function () {
        if (label) label.textContent = S.added || original;
        announce(S.added || '');
        form.dispatchEvent(new CustomEvent('pp:added', { bubbles: true }));
        PP.cart.open(btn);
      })
      .catch(function (err) {
        if (errBox) { errBox.textContent = (err && err.data && err.data.description) || S.cartError || ''; errBox.hidden = false; }
        if (label) label.textContent = original;
      })
      .then(function () {
        form.removeAttribute('data-busy');
        if (btn) btn.removeAttribute('aria-disabled');
        if (label) setTimeout(function () { if (!form.getAttribute('data-busy')) label.textContent = original; }, 1800);
      });
  });

  /* ---------- Vignettes couleur sur les cartes produit (image + lien) ---------- */
  document.addEventListener('click', function (e) {
    var sw = e.target.closest('[data-card-swatch]');
    if (!sw) return;
    var card = sw.closest('[data-product-card]');
    if (!card) return;
    var img = qs('[data-card-image]', card);
    var src = sw.getAttribute('data-image-src');
    if (img && src) {
      img.src = src;
      var set = sw.getAttribute('data-image-srcset');
      if (set) img.srcset = set;
    }
    qsa('[data-card-swatch]', card).forEach(function (s) { s.setAttribute('aria-pressed', s === sw ? 'true' : 'false'); });
    var variant = sw.getAttribute('data-variant-id');
    var vf = qs('[data-card-variant-input]', card);
    if (vf && variant) vf.value = variant;
    var url = sw.getAttribute('data-url');
    qsa('[data-card-link]', card).forEach(function (a) { if (url) a.href = url; });
    var name = qs('[data-card-color-name]', card);
    if (name) name.textContent = sw.getAttribute('data-color-name') || '';
  });

  /* ---------- Recherche prédictive ---------- */
  qsa('[data-predictive-search]').forEach(function (box) {
    var input = qs('input[type="search"]', box);
    var results = qs('[data-predictive-results]', box);
    if (!input || !results) return;
    var timer, controller;
    function hide() { results.hidden = true; input.setAttribute('aria-expanded', 'false'); }
    on(input, 'input', function () {
      clearTimeout(timer);
      var q = input.value.trim();
      if (q.length < 2) { hide(); return; }
      timer = setTimeout(function () {
        if (controller) controller.abort();
        controller = new AbortController();
        var url = (cfg.predictiveSearchUrl || '/search/suggest') + '?q=' + encodeURIComponent(q) +
          '&resources[type]=product,collection,page&resources[limit]=6&section_id=predictive-search';
        fetch(url, { signal: controller.signal }).then(function (r) { return r.text(); }).then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = qs('[data-predictive-content]', doc);
          if (!fresh) { hide(); return; }
          results.replaceChildren.apply(results, Array.prototype.slice.call(fresh.childNodes));
          results.hidden = false;
          input.setAttribute('aria-expanded', 'true');
        }).catch(function (err) { if (err.name !== 'AbortError') hide(); });
      }, 220);
    });
    on(box, 'keydown', function (e) { if (e.key === 'Escape') { hide(); input.focus(); } });
    on(document, 'click', function (e) { if (!box.contains(e.target)) hide(); });
  });

  /* ---------- Préférences cookies (Customer Privacy API de Shopify, si la bannière est active) ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-cookie-preferences]');
    if (!b) return;
    e.preventDefault();
    var cp = window.Shopify && window.Shopify.customerPrivacy;
    if (cp && typeof cp.showPreferences === 'function') cp.showPreferences();
    else if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) {
        if (!err && window.Shopify.customerPrivacy && window.Shopify.customerPrivacy.showPreferences) window.Shopify.customerPrivacy.showPreferences();
      });
    }
  });

  /* Inclinaison 3D légère ([data-tilt]) : souris uniquement et mouvement non réduit, sinon rendu statique inchangé */
  if (window.matchMedia('(hover: hover) and (pointer: fine)').matches && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    document.documentElement.classList.add('pp-tilt');
    var tiltEl = null, tiltRect = null, tiltRaf = 0, tiltX = 0, tiltY = 0;
    var tiltReset = function () {
      if (tiltEl) { tiltEl.classList.remove('is-tilting'); tiltEl.style.removeProperty('--rx'); tiltEl.style.removeProperty('--ry'); }
      tiltEl = null;
    };
    var tiltApply = function () {
      tiltRaf = 0;
      if (!tiltEl) return;
      var max = parseFloat(tiltEl.getAttribute('data-tilt')) || 5;
      var x = Math.min(0.5, Math.max(-0.5, (tiltX - tiltRect.left) / tiltRect.width - 0.5));
      var y = Math.min(0.5, Math.max(-0.5, (tiltY - tiltRect.top) / tiltRect.height - 0.5));
      tiltEl.style.setProperty('--ry', (x * 2 * max).toFixed(2) + 'deg');
      tiltEl.style.setProperty('--rx', (-y * 2 * max).toFixed(2) + 'deg');
    };
    on(document, 'pointermove', function (e) {
      if (e.pointerType !== 'mouse') return;
      var el = e.target.closest ? e.target.closest('[data-tilt]') : null;
      if (el !== tiltEl) {
        tiltReset();
        if (!el) return;
        tiltEl = el;
        tiltRect = el.getBoundingClientRect(); /* mesuré une fois pour éviter le tremblement */
        el.classList.add('is-tilting');
      }
      tiltX = e.clientX; tiltY = e.clientY;
      if (!tiltRaf) tiltRaf = requestAnimationFrame(tiltApply);
    }, { passive: true });
    on(document.documentElement, 'mouseleave', tiltReset);
    on(window, 'scroll', tiltReset, { passive: true });
  }

  /* Section Editor : réinitialise les révélations quand une section est rechargée */
  document.addEventListener('shopify:section:load', function (e) {
    if (PP.observeReveals) PP.observeReveals(e.target);
    else qsa('[data-reveal]', e.target).forEach(function (el) { el.classList.add('is-in'); });
  });
})();
